import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemePreference } from '../lib/useTheme';

const OPTIONS: { value: ThemePreference; label: string; Icon: typeof Sun }[] = [
  { value: 'light', label: 'Light', Icon: Sun },
  { value: 'dark', label: 'Dark', Icon: Moon },
  { value: 'system', label: 'System', Icon: Monitor },
];

/**
 * Three-state theme control for the account menu.
 *
 * Semantics are `menuitemradio` inside a `role="group"`, not the tablist that
 * components/SegmentedToggle.tsx uses: this renders inside the account popover's `role="menu"`,
 * and a tablist nested in a menu is an invalid ARIA structure that axe flags.
 */
export function ThemePicker() {
  const { preference, setPreference } = useTheme();

  return (
    <div className="px-4 py-2">
      <p className="mb-1.5 text-xs font-medium text-slate-500">Theme</p>
      <div
        role="group"
        aria-label="Theme"
        className="flex items-center gap-0.5 rounded-lg bg-slate-100 p-0.5"
      >
        {OPTIONS.map(({ value, label, Icon }) => {
          const active = value === preference;
          return (
            <button
              key={value}
              type="button"
              role="menuitemradio"
              aria-checked={active}
              aria-label={label}
              title={label}
              onClick={() => setPreference(value)}
              className={`flex flex-1 items-center justify-center rounded-md py-1.5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
                active
                  ? 'bg-surface text-slate-900 shadow-sm'
                  : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
